var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.options)?_c('div',{class:[
    'grid-filter switch',
    {'is-clear': _vm.isClear},
    _vm.options.classes,
    ("field-" + (_vm.config.field))
  ],style:(_vm.options.styles)},[_c('el-form-item',{staticClass:"material-style"},[_c('el-switch',{staticClass:"small",attrs:{"active-color":_vm.options.active.color,"inactive-color":_vm.options.inactive.color,"active-text":_vm.activeLabel,"inactive-text":_vm.inactiveLabel},on:{"input":_vm.handleChangeDebounce},model:{value:(_vm.model),callback:function ($$v) {_vm.model=$$v},expression:"model"}})],1)],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }